import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("xch_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("xch_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const device_id = localStorage.getItem("xch_device_id") || undefined;
    const r = await api.post("/auth/login", { email, password, device_id });
    if (r.data.requires_2fa) {
      return { requires_2fa: true, challenge: r.data.challenge };
    }
    localStorage.setItem("xch_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const twoFactorChallenge = async (challenge, code, isRecovery = false, rememberDevice = false) => {
    const r = await api.post("/auth/2fa/challenge",
      { challenge, code, is_recovery: isRecovery, remember_device: rememberDevice });
    localStorage.setItem("xch_token", r.data.token);
    if (r.data.device_id) {
      localStorage.setItem("xch_device_id", r.data.device_id);
    }
    setUser(r.data.user);
    return r.data.user;
  };
  const refreshMe = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };
  const signup = async (data) => {
    const r = await api.post("/auth/signup", data);
    localStorage.setItem("xch_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem("xch_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, signup, logout, twoFactorChallenge, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
